import { LS_KEYS } from '@constants/local-store';
import { getStorage } from '@utils/local-store';
import axios from 'axios';
import { performResponseData } from '../utils/api';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_SERVICE_NAME}`,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded',
    // 'Access-Control-Allow-Origin': '*',
    // 'Access-Control-Allow-Headers':
    //   'Origin, X-Requested-With, Content-Type, Accept',
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain, */*',
  },
});

const onResponseSuccess = (response: any) => {
  const { data } = response;

  return Promise.resolve({
    ...response,
    data: performResponseData(data),
  });
};

api.interceptors.request.use(function (config) {
  const token = getStorage(LS_KEYS.AUTH_TOKEN);

  config.headers.Authorization = 'Bearer ' + token;

  return config;
});

api.interceptors.response.use(onResponseSuccess);

export default api;
